// extracted by mini-css-extract-plugin
module.exports = {"navHeader":"nav_navHeader__21FXy","textLogo":"nav_textLogo__m3sFC","resume":"nav_resume__3fR0n"};